module.exports = __webpack_public_path__ + "assets/align-justify.26d80b8b.svg";